var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Switch as ChakraSwitch } from '@chakra-ui/react';
import { useCallback } from 'react';
export const Switch = (_a) => {
    var { isChecked = false, onChange } = _a, extraProps = __rest(_a, ["isChecked", "onChange"]);
    const onSwitchChange = useCallback((evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        onChange === null || onChange === void 0 ? void 0 : onChange(evt.target.checked);
    }, [onChange]);
    return _jsx(ChakraSwitch, Object.assign({}, extraProps, { isChecked: isChecked, onChange: onSwitchChange }));
};
export default Switch;
